require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-koffiehokjes.json") })
        }
      }, "path---projecten-koffiehokjes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-koffiehokjes!./.cache/json/projecten-koffiehokjes.json
// module id = 425
// module chunks = 231608221292675